//@ts-nocheck
import React from 'react';
import {ComputerDesktopIcon, DevicePhoneMobileIcon, GlobeAmericasIcon, ServerIcon} from '@heroicons/react/20/solid'
import classNames from "classnames";

const StepQuestions = ({questions, currentStep, handleChange}) => {

    return <React.Fragment>

        <div
            key={currentStep}
            className={`w-full ${
                currentStep > 0 ? 'mt-6' : ''
            }`}
        >
            {questions.map(
                (question, index) =>
                    question.step === currentStep && (
                        <div key={question.name} className="my-4">

                            <div className="mx-auto max-w-2xl space-y-16 divide-y divide-gray-100 lg:mx-0 lg:max-w-none">
                                <div className="grid grid-cols-1 gap-y-10 gap-x-8 lg:grid-cols-3 items-center">
                                    <div>
                                        <h2 className="text-3xl font-bold tracking-tight text-gray-900">
                                            {question.label}
                                        </h2>
                                        <p className="mt-4 leading-7 text-gray-600">
                                            {question.description}
                                        </p>
                                    </div>
                                    <div className=" gap-6 sm:grid-cols-2 lg:col-span-2 lg:gap-8">
                                        <div className="rounded-2xl bg-gray-50 p-10">

                                            <div className="mt-1">

                                                <label className="font-bold">{question.label}</label>
                                                {question.type === 'text' && (
                                                    <input
                                                        type="text"
                                                        name={question.name}
                                                        value={question.value}
                                                        placeholder={question.placeholder}
                                                        onChange={handleChange}
                                                        className="w-full px-3 py-2 mt-1 text-gray-700 border rounded-lg focus:outline-none focus:border-blue-500"
                                                    />
                                                )}
                                                {question.type === 'select' && (
                                                    <select
                                                        name={question.name}
                                                        value={question.value}
                                                        onChange={handleChange}
                                                        className="w-full px-3 py-2 mt-1 text-gray-700 border rounded-lg focus:outline-none focus:border-blue-500"
                                                    >
                                                        <option value="">-- Select an option --</option>
                                                        {question.options.map((option) => (
                                                            <option key={option} value={option}>
                                                                {option}
                                                            </option>
                                                        ))}
                                                    </select>
                                                )}
                                                {question.type === 'project_type' && (

                                                    <div className={'my-4 grid grid-cols-2 lg:grid-cols-4 gap-4'}>
                                                        {[{
                                                            name: 'Web',
                                                            icon: GlobeAmericasIcon
                                                        },
                                                            {name: 'Desktop', icon: ComputerDesktopIcon},
                                                            {
                                                                name: 'Mobile',
                                                                icon: DevicePhoneMobileIcon
                                                            },
                                                            {
                                                                name: 'Other',
                                                                icon: ServerIcon
                                                            }].map((option, idx) => (
                                                            <div key={idx}>
                                                                <button className={
                                                                    classNames({
                                                                        'bg-white hover:bg-gray-200 p-4 lg:p-8 w-full flex items-center flex-col shadow cursor-pointer': true,
                                                                        'bg-gray-200': question.value === option.name
                                                                    })
                                                                } onClick={() => handleChange({
                                                                    target: {
                                                                        name: question.name,
                                                                        value: option.name
                                                                    }
                                                                })}
                                                                >
                                                                    <option.icon className={'w-8 lg:w-24 mb-2'}/>
                                                                    {option.name}
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                                {question.type === 'checkbox' && (
                                                    <div className="mt-1">
                                                        {question.options.map((option, idx) => (
                                                            <div key={`${idx}-${question.value.length}`}
                                                                 className="flex items-center">
                                                                <label className={'cursor-pointer'}>
                                                                    <input
                                                                        type="checkbox"
                                                                        name={question.name}
                                                                        value={option}
                                                                        checked={question.value?.includes(option)}
                                                                        onChange={handleChange}
                                                                        className="mr-2 leading-tight"
                                                                    />
                                                                    {option}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                                {question.type === 'slider' && (
                                                    <div className="mt-4">
                                                        <input
                                                            type="range"
                                                            min={question.min}
                                                            max={question.max}
                                                            step={question.step}
                                                            name={question.name}
                                                            value={question.value}
                                                            onChange={handleChange}
                                                            className="w-full"
                                                        />
                                                        <div className="flex justify-between mt-2">
                                                            <span>{question.minLabel}</span>
                                                            <span>{question.maxLabel}</span>
                                                        </div>
                                                    </div>
                                                )}


                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    )
            )}
        </div>
    </React.Fragment>
};

export default StepQuestions;
